var n = /* @__PURE__ */ ((t) => (t.OK = "ok", t.PASS = "pass", t.POOR = "poor", t))(n || {});
const e = (t) => t && t.length >= 10 ? "ok" : t && t.length >= 6 ? "pass" : "poor", r = (t) => t.length * 10 > 100 ? 100 : t.length * 10;
export {
  n as PasswordProgressEnum,
  r as getPasswordProgressValue,
  e as getPasswordStatus
};
//# sourceMappingURL=utils.js.map
